module.exports = __webpack_public_path__ + "static/media/gopi-kishan.1e8a4479.jpeg";